import {SET_ADVISERS_LIST} from '../mutation-types';
import {getAdvisers} from '@/api/user-api';

const initialState = {
    list: []
};

const mutations = {
    [SET_ADVISERS_LIST](state, advisers) {
        state.list = advisers;
    }
};

const actions = {
    loadAdvisers({commit}) {
        getAdvisers().then(advisers => {
            commit(SET_ADVISERS_LIST, advisers)
        });
    }
};

export default {
    state: initialState,
    mutations,
    actions
}